import { createContext, useContext, useState, useEffect } from 'react';
import moment from 'moment';

const WeekConfigContext = createContext();

export const WeekConfigProvider = ({ children, selectedOrganization }) => {
  const [isWeekStartReady, setIsWeekStartReady] = useState(false);
  const [weekStart, setWeekStart] = useState('monday');

  const dayMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const updateMomentWeekStart = (startDay = 'monday') => {
    try {
      if (dayMap[startDay] !== undefined) {
        moment.updateLocale('en', {
          week: {
            dow: dayMap[startDay],
            doy: 4,
          },
        });

        setWeekStart(startDay);
        localStorage.setItem('start_day_of_week', startDay);
        setIsWeekStartReady(true);
        return true;
      } else {
        moment.updateLocale('en', {
          week: {
            dow: dayMap['monday'],
            doy: 4,
          },
        });

        setWeekStart('monday');
        localStorage.setItem('start_day_of_week', 'monday');
        setIsWeekStartReady(true);

        return false;
      }
    } catch (error) {
      return false;
    }
  };

  // Initialize with stored value on mount
  useEffect(() => {
    const storedStartDay =
      localStorage.getItem('start_day_of_week') || 'monday';
    updateMomentWeekStart(storedStartDay);
  }, []);

  // Watch for selectedOrganization configuration changes
  useEffect(() => {
    if (selectedOrganization?.configuration?.start_day_of_week) {
      const orgStartDay = selectedOrganization.configuration.start_day_of_week;
      const currentWeekStart = weekStart;

      // Only update if the value is actually different to prevent unnecessary updates
      if (currentWeekStart !== orgStartDay) {
        updateMomentWeekStart(orgStartDay);
      }
    }
  }, [selectedOrganization?.configuration?.start_day_of_week]);

  const value = {
    isWeekStartReady,
    weekStart,
    updateMomentWeekStart,
  };

  return (
    <WeekConfigContext.Provider value={value}>
      {children}
    </WeekConfigContext.Provider>
  );
};

export const useWeekConfig = () => {
  const context = useContext(WeekConfigContext);
  if (!context) {
    throw new Error('useWeekConfig must be used within WeekConfigProvider');
  }
  return context;
};

export const weekDayMap = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

// export const changeWeekStartDay = (startDay) => {
//   console.log('Changing week start day to:', startDay);
//   moment.updateLocale('en', {
//     week: {
//       dow: weekDayMap[startDay] || 1,
//       doy: 4,
//     },
//   });
//   localStorage.setItem('start_day_of_week', startDay);

// }